import * as accountHooksMethods from './account_hooks'
import * as accountRolePreferenceMethods from './account_role_preferences'
import * as accountRolesMethods from './account_roles'
import * as accountsMethods from './accounts'
import * as apiApplicationsMethods from './api_applications'
import * as apiKeyMethods from './api_key'
import * as attachments from './attachments'
import * as billingMethods from './billing'
import * as brandingMethods from './branding'
import * as bulkSendsMethods from './bulk_sends'
import * as completionMethods from './completions'
import * as contactMethods from './contacts'
import * as contactPlaceholderMethods from './contact_placeholders'
import * as documentMethods from './documents'
import * as documentContactMethods from './document_contacts'
import * as documentContactPlaceholderMethods from './document_contact_placeholders'
import * as documentFileMethods from './document_files'
import * as documentTemplateMethods from './document_templates'
import * as documentablePreferencesMethods from './documentable_preferences'
import * as eventMethods from './events'
import * as hooksMethods from './hooks'
import * as inviteMethods from './invites'
import * as labelMethods from './labels'
import * as multiStepSignupMethods from './multi_step_signup'
import * as onboardingMethods from './onboardings'
import * as organizationMethods from './organizations'
import * as signingElementMethods from './signing_elements'
import * as sendingMethods from './sendings'
import * as sendingTemplateMethods from './sending_templates'
import * as teamMembersMethods from './teams'
import * as templateLinkMethods from './template_links'
import * as templatePlaceholderMethods from './template_placeholders'
import * as trackingMethods from './trackings'
import * as transferOwnershipsMethods from './transfer_ownerships'
import * as uploadedSignatures from './uploaded_signatures'
import * as userPreferenceMethods from './user_preferences'

const apiActions = {
  ...accountHooksMethods,
  ...accountRolePreferenceMethods,
  ...accountRolesMethods,
  ...accountsMethods,
  ...apiApplicationsMethods,
  ...apiKeyMethods,
  ...attachments,
  ...billingMethods,
  ...brandingMethods,
  ...bulkSendsMethods,
  ...completionMethods,
  ...contactMethods,
  ...contactPlaceholderMethods,
  ...documentMethods,
  ...documentContactMethods,
  ...documentContactPlaceholderMethods,
  ...documentFileMethods,
  ...documentTemplateMethods,
  ...documentablePreferencesMethods,
  ...eventMethods,
  ...hooksMethods,
  ...inviteMethods,
  ...labelMethods,
  ...multiStepSignupMethods,
  ...onboardingMethods,
  ...organizationMethods,
  ...sendingMethods,
  ...sendingTemplateMethods,
  ...signingElementMethods,
  ...teamMembersMethods,
  ...templateLinkMethods,
  ...templatePlaceholderMethods,
  ...trackingMethods,
  ...transferOwnershipsMethods,
  ...uploadedSignatures,
  ...userPreferenceMethods,
}

export default apiActions
